import React, { memo } from 'react';
import { makeStyles } from '@mui/styles';
import { Grid, Tooltip, Checkbox, FormControlLabel } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import CheckBoxOutlinedIcon from '@mui/icons-material/CheckBoxOutlined';
import { Controller } from 'react-hook-form';

import {
  LEAVE_FROM_SATELLITE_DEPOT_TOOLTIP,
  LOCKDOWN_TOOLTIP,
  RETURN_TO_SATELLITE_DEPOT_TOOLTIP,
} from '../messages';
import palette from '../../../components/styles/palette';
import { View } from '../../../components/Base';

const useStyles = makeStyles(({ typography }) => ({
  container: {
    paddingLeft: '0.5rem',
    paddingBottom: '1.5rem',
  },
  item: {
    display: 'flex',
    height: typography.pxToRem(20),
  },
  labelText: {
    fontSize: typography.pxToRem(12),
    lineHeight: typography.pxToRem(20),
    color: palette.typography.black.solid,
  },
  tooltip: {
    color: palette.typography.black.disabled,
    paddingLeft: '0.5rem',
  },
}));

const DriverCheckboxes = ({ isDisabled, control }) => {
  const styles = useStyles();

  return (
    <View className={styles.container}>
      <Grid item xs={12} className={styles.item}>
        <Controller
          name="saturnLockdown"
          control={control}
          render={({ field }) => (
            <FormControlLabel
              control={
                <Checkbox
                  {...field}
                  checked={!!field.value}
                  disabled={isDisabled}
                  checkedIcon={<CheckBoxOutlinedIcon />}
                  data-testid="saturn-lockdown"
                />
              }
              label={<View className={styles.labelText}>Lockdown</View>}
            />
          )}
        />
        <Tooltip
          title={LOCKDOWN_TOOLTIP}
          placement="right-start"
          fontSize="small"
          className={styles.tooltip}
        >
          <InfoOutlinedIcon />
        </Tooltip>
      </Grid>
      <Grid item xs={12} className={styles.item}>
        <Controller
          name="startAtSatellite"
          control={control}
          render={({ field }) => (
            <FormControlLabel
              control={
                <Checkbox
                  {...field}
                  checked={!!field.value}
                  disabled={isDisabled}
                  checkedIcon={<CheckBoxOutlinedIcon />}
                  data-testid="start-at-satellite"
                />
              }
              label={
                <View className={styles.labelText}>
                  Leave From Satellite Depot
                </View>
              }
            />
          )}
        />
        <Tooltip
          title={LEAVE_FROM_SATELLITE_DEPOT_TOOLTIP}
          placement="right-start"
          fontSize="small"
          className={styles.tooltip}
        >
          <InfoOutlinedIcon />
        </Tooltip>
      </Grid>
      <Grid item xs={12} className={styles.item}>
        <Controller
          name="endAtSatellite"
          control={control}
          render={({ field }) => (
            <FormControlLabel
              control={
                <Checkbox
                  {...field}
                  checked={!!field.value}
                  disabled={isDisabled}
                  checkedIcon={<CheckBoxOutlinedIcon />}
                  data-testid="end-at-satellite"
                />
              }
              label={
                <View className={styles.labelText}>
                  Return to Satellite Depot
                </View>
              }
            />
          )}
        />
        <Tooltip
          title={RETURN_TO_SATELLITE_DEPOT_TOOLTIP}
          placement="right-start"
          fontSize="small"
          className={styles.tooltip}
        >
          <InfoOutlinedIcon />
        </Tooltip>
      </Grid>
    </View>
  );
};

export default memo(DriverCheckboxes);
